// E-commerce cart state management
export const cartState = {
  items: [],
  total: 0
};

// Cart functions
export const addToCart = (product, quantity = 1, addons = []) => {
  const cartItem = {
    id: `${product.id}-${Date.now()}`,
    productId: product.id,
    name: product.name,
    price: parseFloat(product.price.replace('₹', '').replace(',', '')),
    quantity: quantity,
    image: product.image,
    category: product.category,
    addons: addons // Installation, AMC, etc.
  };
  
  cartState.items.push(cartItem);
  calculateTotal();
  saveCart();
  return cartItem;
};

export const removeFromCart = (itemId) => {
  cartState.items = cartState.items.filter(item => item.id !== itemId);
  calculateTotal();
  saveCart();
};

export const updateQuantity = (itemId, quantity) => {
  const item = cartState.items.find(i => i.id === itemId);
  if (item) {
    item.quantity = quantity;
    calculateTotal();
    saveCart();
  }
};

export const calculateTotal = () => {
  cartState.total = cartState.items.reduce((sum, item) => {
    const itemTotal = item.price * item.quantity;
    const addonsTotal = item.addons.reduce((addonSum, addon) => addonSum + addon.price, 0);
    return sum + itemTotal + addonsTotal;
  }, 0);
  return cartState.total;
};

export const clearCart = () => {
  cartState.items = [];
  cartState.total = 0;
  saveCart();
};

export const getCart = () => {
  loadCart();
  return { ...cartState };
};

export const getCartCount = () => {
  return cartState.items.reduce((sum, item) => sum + item.quantity, 0);
};

// Local storage
const saveCart = () => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('nilomanCart', JSON.stringify(cartState));
  }
};

const loadCart = () => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('nilomanCart');
    if (saved) {
      const parsed = JSON.parse(saved);
      cartState.items = parsed.items || [];
      cartState.total = parsed.total || 0;
    }
  }
};

// Add-ons available
export const availableAddons = [
  {
    id: 'installation',
    name: 'Professional Installation',
    price: 2999,
    description: 'Expert installation with 6-month service warranty'
  },
  {
    id: 'amc-basic',
    name: 'Basic AMC (1 Year)',
    price: 1999,
    description: '2 service visits, parts extra'
  },
  {
    id: 'amc-premium',
    name: 'Premium AMC (1 Year)',
    price: 2999,
    description: '4 service visits, parts included'
  },
  {
    id: 'extended-warranty',
    name: 'Extended Warranty (2 Years)',
    price: 3999,
    description: 'Additional 2-year coverage beyond standard warranty'
  }
];

// Mock orders storage
export const ordersState = {
  orders: []
};

export const createOrder = (orderData) => {
  const order = {
    id: `ORD${Date.now()}`,
    ...orderData,
    status: 'pending',
    createdAt: new Date().toISOString()
  };
  
  ordersState.orders.push(order);
  saveOrders();
  return order;
};

export const getOrders = () => {
  loadOrders();
  return [...ordersState.orders];
};

const saveOrders = () => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('nilomanOrders', JSON.stringify(ordersState));
  }
};

const loadOrders = () => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('nilomanOrders');
    if (saved) {
      const parsed = JSON.parse(saved);
      ordersState.orders = parsed.orders || [];
    }
  }
};
